import { startGame, stopGame } from './game.js';
import { loadMapsSdk } from './mapsSdk.js';
import { createLocationPicker } from './locationPicker.js';
import { initSearchUI } from './searchUI.js';
import { TOTAL_SITES } from './historicSites.js';
import { progress } from './historicProgress.js';

const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
const statusLine = document.getElementById('status-line');

if (!apiKey || apiKey === 'YOUR_KEY_HERE') {
  if (statusLine) {
    statusLine.textContent =
      '.env に VITE_GOOGLE_MAPS_API_KEY を設定してください (Map Tiles API を有効化)';
  }
  console.error('VITE_GOOGLE_MAPS_API_KEY is not set');
}

const titleEl = document.getElementById('title-screen');
const gameEl = document.getElementById('game-root');
let activeGame = null;
let picker = null;

// タイトル画面の「世界史スポット n / N 訪問済み」行とプログレスバー。
function renderVisitProgress() {
  const line = document.getElementById('visit-progress');
  const fill = document.getElementById('visit-progress-fill');
  const visited = progress.size;
  if (line) {
    line.textContent = visited === 0
      ? `世界史スポットを巡ろう / Fly through the glowing rings（全 ${TOTAL_SITES} 箇所）`
      : `世界史スポット ${visited} / ${TOTAL_SITES} 訪問済み / Historic sites visited`;
  }
  if (fill) fill.style.width = `${TOTAL_SITES ? (visited / TOTAL_SITES) * 100 : 0}%`;
}

function showTitle() {
  if (activeGame) {
    stopGame(activeGame);
    activeGame = null;
  }
  gameEl.hidden = true;
  titleEl.hidden = false;
  picker?.reset();
  renderVisitProgress();
}

function onCityChosen({ lat, lng, name, elevation, lookAt }) {
  if (!apiKey) return;
  titleEl.hidden = true;
  gameEl.hidden = false;
  activeGame = startGame({ lat, lng, name, apiKey, elevation, lookAt });
}

window.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape' || !activeGame) return;
  // 解説モーダルが開いていれば、まず閉じて飛行を再開する。
  // もう一度 Escape を押すと従来どおり都市選択画面へ戻る。
  if (activeGame.handleEscape?.()) return;
  showTitle();
});

renderVisitProgress();

if (apiKey && apiKey !== 'YOUR_KEY_HERE') {
  // Pre-load the Maps SDK so the in-game minimap is ready when needed.
  loadMapsSdk(apiKey).catch((e) => {
    console.warn('Maps SDK preload failed:', e);
  });

  // 地域 → 国 → 都市 の階層選択ピッカー。
  picker = createLocationPicker({
    container: document.getElementById('location-picker'),
    leadEl: document.getElementById('picker-lead'),
    onChoose: onCityChosen,
  });

  // 都市名で検索して出発（Places オートコンプリート）。ピッカーの段階に関係なく常時表示。
  initSearchUI({
    apiKey,
    onCityChosen,
    onError: (msg) => { if (statusLine) statusLine.textContent = msg; },
  });
}
